"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.configureDatadog = void 0;
const index_1 = require("@App/configs/index");
const browser_rum_1 = require("@datadog/browser-rum");
const package_json_1 = __importDefault(require("../../package.json"));
const configureDatadog = () => {
    var _a, _b, _c;
    const isQA = index_1.configuration.env === 'qa' || index_1.configuration.env === 'dev';
    browser_rum_1.datadogRum.init({
        applicationId: (_a = index_1.configuration.datadog_app_id) !== null && _a !== void 0 ? _a : '',
        clientToken: (_b = index_1.configuration.datadog_client_token) !== null && _b !== void 0 ? _b : '',
        site: 'datadoghq.com',
        service: 'mlc-portal',
        env: (_c = index_1.configuration.env) !== null && _c !== void 0 ? _c : 'local',
        version: package_json_1.default.version,
        startSessionReplayRecordingManually: true,
        allowedTracingUrls: [index_1.configuration.api, index_1.configuration.api2v],
        sessionSampleRate: 100,
        sessionReplaySampleRate: 100, // if not included, the default is 100
        trackResources: true,
        trackLongTasks: true,
        trackUserInteractions: true,
        defaultPrivacyLevel: isQA ? 'allow' : 'mask',
    });
    if (isQA) {
        browser_rum_1.datadogRum.startSessionReplayRecording();
    }
};
exports.configureDatadog = configureDatadog;
